"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var AuthButtons_1 = require("../../AuthButtons");
var ChangeLanguage_1 = require("../../ChangeLanguage");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var NotAuthMenu = function (_a) {
    var languages = _a.languages, searchRightMobile = _a.searchRightMobile, showSignUp = _a.showSignUp;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var signIn = (0, apps_shared_1.useOpenSignIn)();
    var openSearch = (0, apps_shared_1.useOpenGameSearch)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(AuthButtons_1.AuthButtons, { showSignUp: showSignUp }),
            react_1.default.createElement(ChangeLanguage_1.ChangeLanguage, { isAuth: true, languages: languages }))),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) &&
            !searchRightMobile && (react_1.default.createElement("div", { onClick: signIn, className: "".concat(styles_module_scss_1.default.buttonWrapper) },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", height: "32px" }, t('login')))),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) &&
            searchRightMobile && (react_1.default.createElement("button", { className: styles_module_scss_1.default.searchButton, onClick: openSearch }))));
};
exports.default = NotAuthMenu;
